import Container from '@ui/container/container';
import Leaderboard from '../../leaderboard/leaderboard';

const LeaderboardSettings = () => {
  return (
    <Container background="none" className="flex flex-column margin-b-32">
      <Leaderboard />
    </Container>
  );
};

export default LeaderboardSettings;
